import { render } from "./predictile_logo_rgb.svg?vue&type=template&id=528323f5"
import script from "./predictile_logo_rgb.svg?vue&type=script&lang=js"
export * from "./predictile_logo_rgb.svg?vue&type=script&lang=js"

import "./predictile_logo_rgb.svg?vue&type=style&index=0&id=528323f5&lang=css"

import exportComponent from "/codebuild/output/src3352/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__